module.exports = __webpack_public_path__ + "static/media/qua1.8e6ab9ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/qua1.jpg
// module id = 139
// module chunks = 0